import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '../_services';
import { AlertMessage, AlertType } from '../_models';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-alert',
  templateUrl: 'alert.component.html',
  styleUrls: ['alert.component.scss'],
})
export class AlertComponent implements OnInit {
  messages: AlertMessage[] = [];
  @Input('toastEnabled') toastEnabled: boolean = true;

  constructor(private alertService: AlertService) {}

  ngOnInit() {
    this.alertService.getMessage().subscribe((messages: AlertMessage[]) => {
      this.messages = messages || [];
    });
  }

  isSuccess(message: AlertMessage): boolean {
    return message && message.type === AlertType.Success;
  }

  isError(message: AlertMessage): boolean {
    return message && message.type === AlertType.Error;
  }

  closeAlert(messageId: number) {
    this.alertService.removeMessage(messageId);
  }

  trackByMessageId(index: number, message: AlertMessage): any {
    return message.id;
  }

  getAlertStyles(index: number, total: number) {
    const baseOffset = index * 16; // Base spacing
    const scaleCompensation = index * 4; // Extra offset to compensate for scaling effect
    const stackOffset = baseOffset + scaleCompensation;
    const scale = 1 - index * 0.05; // Progressive scaling: 1.0, 0.95, 0.90, etc.
    const actualWidth = Math.floor(340 * scale); // Calculate actual width instead of using transform scale
    const zIndex = 1005 + (total - index); // Higher z-index for newer alerts
    const opacity = index >= 3 ? 0.7 : 0.9; // Slightly reduce opacity for deeper alerts

    return {
      position: 'absolute',
      top: `${stackOffset}px`,
      right: '0px',
      'transform-origin': 'top right',
      'z-index': zIndex,
      opacity: opacity,
      width: `${actualWidth}px`,
      'min-width': `${actualWidth}px`,
      'max-width': `${actualWidth}px`,
    };
  }
}
